import * as React from 'react'
import { Tooltip } from '@dvui'
import * as cn from 'classnames'
import * as st from './FilterTooltip.module.scss'

const LOCAL_STORAGE_FLAG = "knowsAboutTheFilterAlready"

const hasLocalStorageFlag = () => (
    !global.__SERVER__ && Boolean(window && window.localStorage && window.localStorage.getItem(LOCAL_STORAGE_FLAG))
)

const setLocalStorageFlag = () => (
    !global.__SERVER__ && window && window.localStorage && window.localStorage.setItem(LOCAL_STORAGE_FLAG, 'Sure does!')
)

interface FilterConditionalProps {
    children?: React.ReactChild, 
    tooltipLabel: string, 
    className?: string
}


interface MountedState {
    mounted: boolean
}

export class FilterConditionalToolip extends React.PureComponent<FilterConditionalProps, MountedState> {
    constructor(props: FilterConditionalProps) {
        super(props)
        this.state = { mounted: false }
    }

    componentDidMount() {
        this.setState({ mounted: true })
    }

    render() {

        if (this.props.tooltipLabel != undefined && Boolean(this.props.tooltipLabel) &&
            !hasLocalStorageFlag() && this.state.mounted) {
            return <Tooltip
                startOpen={true}
                dismissable={true}
                content={this.props.tooltipLabel}
                className={cn(this.props.className, st.tooltip)}
                use={'info'}
                size={'m'}
                onDismiss={() => setLocalStorageFlag()}
                position={'bottom'}>
                {this.props.children}
            </Tooltip>
        }
        return this.props.children
    }
}